export default "__VITE_PUBLIC_ASSET__1f47a366__"